import React from "react";

/**
 * Wrapper component for control sections with consistent styling
 */
const ControlSection = ({ children, style = {} }) => {
  return (
    <div
      style={{
        background: "#f5f5f5",
        borderRadius: "8px",
        padding: "10px 12px",
        marginBottom: "12px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default ControlSection;
